import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerExperienceChatModel, CustomerExperienceTicketAttachment, CustomerExperienceTicketDetailChatHeaderModel } from '@core/api';
import { dropdownAnimation } from 'src/app/shared/animations/dropdown.animation';
import { fadeInUp400ms } from 'src/app/shared/animations/fade-in-up.animation';
import { Icon } from '@shared/enums';

type CXMailViewModel = { self: boolean, headerInfo: CustomerExperienceTicketDetailChatHeaderModel } & CustomerExperienceChatModel;

@Component({
  selector: 'net-customer-experience-mail-viewer',
  templateUrl: './customer-experience-mail-viewer.component.html',
  styleUrls: ['./customer-experience-mail-viewer.component.scss'],
  animations: [
    fadeInUp400ms,
    dropdownAnimation,
  ]
})
export class CustomerExperienceMailViewerComponent implements OnInit {

  icClose = Icon.IC_TWOTONE_CLOSE;
  icArrowDropUp = Icon.IC_TWOTONE_ARROW_DROP_UP;
  icArrowDropDown = Icon.IC_TWOTONE_ARROW_DROP_DOWN;

  contactDrawer = false;

  readonly defaultStyle = `body { margin: 0; padding: 0 }
      figure {
        table, th, td {
          padding: 0.5rem;
          border: 1px solid rgb(0, 0, 0, 0.5);
          border-collapse: collapse;
        }
      }
   `;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CXMailViewModel
  ) { }

  ngOnInit(): void {

  }

  toggleContactDrawer() {
    this.contactDrawer = !this.contactDrawer;
  }

  formattedRecipients(email: string, cc: boolean = false): string {
    const cxChannelInfo = this.data?.ticketMessage?.cxChannel?.cxChannelInfo;

    if (cc) {
      return email.split(',').map(mail => mail.trim()).join(', ');
    }

    if (email) {
      const formattedMail = email.split(',').map(mail => mail.trim()).join(', ');
      return cxChannelInfo ? `${formattedMail}, ${cxChannelInfo}` : formattedMail;
    }
    return cxChannelInfo || '';
  }

  get ticketMessageAttachments(): CustomerExperienceTicketAttachment[] {
    return this.data?.ticketMessage?.ticketMessageAttachments || [];
  }
}
